import { styled } from '@mui/material/styles';
import { Box, Typography, Select, TextField, Button } from '@mui/material';

// ============================================
// Content Area
// ============================================
export const ChargeContentArea = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  flex: 1,
  overflow: 'hidden',
});

export const ChargeScrollArea = styled(Box)({
  flex: 1,
  overflowY: 'auto',
  padding: '32px',
});

export const ChargeFooter = styled(Box)({
  display: 'flex',
  gap: '16px',
  alignItems: 'center',
  justifyContent: 'center',
  padding: '24px 32px',
  borderTop: '1px solid #f2f2f2',
  flexShrink: 0,
});

// ============================================
// Info Section
// ============================================
export const ChargeInfoSection = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  gap: '24px',
  width: '100%',
});

export const ChargeInfoRow = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  width: '100%',
});

export const ChargeInfoLabel = styled(Typography)({
  fontSize: '16px',
  fontWeight: 600,
  color: '#262626',
  width: '100px',
  flexShrink: 0,
});

export const ChargeInfoValue = styled(Typography)({
  fontSize: '16px',
  fontWeight: 500,
  color: '#262626',
  whiteSpace: 'nowrap',
});

export const ChargeCountValue = styled(Typography)({
  display: 'flex',
  alignItems: 'center',
  gap: '4px',
  fontSize: '20px',
  fontWeight: 500,
  color: '#262626',
  whiteSpace: 'nowrap',
});

export const ChargeCountUnit = styled('span')({
  fontSize: '16px',
  fontWeight: 500,
});

// ============================================
// Select
// ============================================
export const ChargeSelectWrapper = styled(Box)({
  width: '326px',
});

export const ChargeSelect = styled(Select)({
  width: '100%',
  height: '48px',
  borderRadius: '6px',
  fontSize: '16px',
  fontWeight: 500,
  color: '#262626',
  '& .MuiOutlinedInput-notchedOutline': {
    borderColor: '#d9d9d9',
  },
  '&:hover .MuiOutlinedInput-notchedOutline': {
    borderColor: '#bfbfbf',
  },
  '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
    borderColor: '#4ab3bc',
  },
  '& .MuiSelect-select': {
    padding: '12px 16px',
  },
  '& .MuiSelect-icon': {
    color: '#a6a6a6',
  },
});

// ============================================
// Notice
// ============================================
export const ChargeNoticeBox = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: '16px',
  backgroundColor: '#f2f2f2',
  borderRadius: '8px',
  width: '100%',
});

export const ChargeNoticeText = styled(Typography)({
  fontSize: '14px',
  fontWeight: 500,
  color: '#262626',
});

// ============================================
// Step2 - 결제 정보
// ============================================
export const FieldGroup = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  gap: '12px',
  width: '100%',
});

export const FieldLabel = styled(Typography)({
  fontSize: '16px',
  fontWeight: 600,
  color: '#141414',
});

export const FieldInput = styled(TextField)({
  width: '100%',
  '& .MuiOutlinedInput-root': {
    height: '44px',
    borderRadius: '4px',
    fontSize: '14px',
    fontWeight: 500,
    '& fieldset': {
      borderColor: '#a6a6a6',
    },
    '&:hover fieldset': {
      borderColor: '#737373',
    },
    '&.Mui-focused fieldset': {
      borderColor: '#4ab3bc',
    },
  },
  '& .MuiOutlinedInput-input': {
    padding: '12px 16px',
  },
});

export const FieldSelect = styled(Select)({
  width: '100%',
  height: '44px',
  borderRadius: '4px',
  fontSize: '14px',
  fontWeight: 500,
  color: '#262626',
  '& .MuiOutlinedInput-notchedOutline': {
    borderColor: '#a6a6a6',
  },
  '&:hover .MuiOutlinedInput-notchedOutline': {
    borderColor: '#737373',
  },
  '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
    borderColor: '#4ab3bc',
  },
  '& .MuiSelect-select': {
    padding: '12px 16px',
  },
  '& .MuiSelect-icon': {
    color: '#a6a6a6',
  },
});

export const RadioSection = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  gap: '16px',
  width: '100%',
});

export const RadioGroup = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
});

export const RadioGroupLabel = styled(Typography)({
  fontSize: '14px',
  fontWeight: 600,
  color: '#404040',
});

export const RadioOptionsRow = styled(Box)({
  display: 'flex',
  gap: '32px',
  alignItems: 'center',
  height: '44px',
  '& .MuiFormControlLabel-root': {
    marginLeft: 0,
    marginRight: 0,
    gap: '8px',
  },
});

export const Divider = styled(Box)({
  width: '100%',
  height: '2px',
  backgroundColor: '#f2f2f2',
});

export const TotalRow = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  width: '100%',
});

export const TotalLabel = styled(Typography)({
  fontSize: '20px',
  fontWeight: 600,
  color: '#333',
});

export const TotalPrice = styled(Typography)({
  fontSize: '20px',
  fontWeight: 600,
  color: '#4ab3bc',
});

export const PrevButton = styled(Button)({
  width: '120px',
  height: '48px',
  borderRadius: '8px',
  border: '1px solid #4ab3bc',
  backgroundColor: '#fff',
  color: '#4ab3bc',
  fontSize: '20px',
  fontWeight: 600,
  textTransform: 'none',
  boxShadow: 'none',
  '&:hover': {
    backgroundColor: 'rgba(74, 179, 188, 0.08)',
    border: '1px solid #4ab3bc',
    boxShadow: 'none',
  },
});

// ============================================
// Step3 - 확인 정보
// ============================================
export const ConfirmSection = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  gap: '18px',
  width: '100%',
});

export const ConfirmRow = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  width: '100%',
});

export const ConfirmLabel = styled(Typography)({
  fontSize: '16px',
  fontWeight: 500,
  color: '#737373',
  width: '107px',
});

export const ConfirmValue = styled(Typography)({
  fontSize: '16px',
  fontWeight: 500,
  color: '#333',
  whiteSpace: 'nowrap',
});

export const ConfirmValueBold = styled(Typography)({
  fontSize: '16px',
  fontWeight: 600,
  color: '#333',
  whiteSpace: 'nowrap',
});
